import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["element"]

    remove(event) {
        event.preventDefault()
        event.target.closest('[data-dynamic-fields-target]').remove();
    }
}
